export const avatarStyles = [
  {
    value: 'avatar-style-01',
    isPro: false,
  },
  {
    value: 'avatar-style-02',
    isPro: true,
  },
  {
    value: 'avatar-style-03',
    isPro: true,
  },
  {
    value: 'avatar-style-04',
    isPro: true,
  },
  {
    value: 'avatar-style-05',
    isPro: true,
  },
  {
    value: 'avatar-style-06',
    isPro: true,
  },
  {
    value: 'avatar-style-07',
    isPro: true,
  },
  {
    value: 'avatar-style-08',
    isPro: true,
  },
  {
    value: 'avatar-style-09',
    isPro: true,
  },
  {
    value: 'avatar-style-10',
    isPro: true,
  },
];
